import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import authService from '../services/AuthService';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMessage('Token de verificación no encontrado.');
      return;
    }

    authService.verifyEmail(token)
      .then(() => {
        setStatus('success');
        setTimeout(() => navigate('/', { replace: true }), 2000);
      })
      .catch((err) => {
        setStatus('error');
        setErrorMessage(err.message || 'El enlace de verificación no es válido o ha caducado.');
      });
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 420, p: 1 }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography variant="h4" fontWeight={700} color="primary" gutterBottom>
            Concordare
          </Typography>

          {status === 'verifying' && (
            <>
              <CircularProgress sx={{ mt: 3, mb: 2 }} />
              <Typography variant="body1" color="text.secondary">
                Verificando tu cuenta...
              </Typography>
            </>
          )}

          {status === 'success' && (
            <>
              <Typography variant="h6" fontWeight={600} mt={2} mb={1}>
                Cuenta verificada
              </Typography>
              <Alert severity="success" sx={{ mb: 2, textAlign: 'left' }}>
                Tu email ha sido verificado correctamente. Redirigiendo...
              </Alert>
            </>
          )}

          {status === 'error' && (
            <>
              <Typography variant="h6" fontWeight={600} mt={2} mb={1}>
                Error de verificación
              </Typography>
              <Alert severity="error" sx={{ mb: 2, textAlign: 'left' }}>
                {errorMessage}
              </Alert>
              <Button
                component={RouterLink}
                to="/register"
                variant="outlined"
                sx={{ mr: 1 }}
              >
                Registrarse de nuevo
              </Button>
              <Button
                component={RouterLink}
                to="/login"
                variant="contained"
              >
                Iniciar sesión
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
